import { logEvent } from "./field_logger"

// Card #4007 -- the app logs carry no version column, so a phone updating
// was visible but not to what. The running version comes from the layout's
// <meta name="app-version"> tag.
export const LAST_APP_VERSION_KEY = "field:last_app_version"

export function runningAppVersion() {
  if (typeof document === "undefined") return null
  return document.querySelector('meta[name="app-version"]')?.content || null
}

// Logs "App version changed" {previous, current} when this phone last saw a
// different version. First run (nothing stored) just records it, quietly.
export function logAppVersionChange() {
  const current = runningAppVersion()
  if (!current) return

  let previous = null
  try {
    previous = localStorage.getItem(LAST_APP_VERSION_KEY)
    if (previous === current) return
    localStorage.setItem(LAST_APP_VERSION_KEY, current)
  } catch {
    return // storage unavailable -- nothing to compare against
  }

  if (previous) logEvent("sw", "App version changed", { previous, current }).catch(() => {})
}
